import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Cria o contexto
const AuthContext = createContext();

// Hook para facilitar o uso
export const useAuth = () => useContext(AuthContext);

// Provider que encapsula toda a aplicação
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const nickname = localStorage.getItem("nickname");
    const gender = localStorage.getItem("gender");
    const userId = localStorage.getItem("userId");
    const admin = localStorage.getItem("admin");
    if (token && nickname && gender && userId) {
      setUser({ nickname, token, gender, userId, admin: Number(admin) });
    }
    setLoading(false);
  }, []);

  const login = ({ nickname, token, gender, userId, admin }) => {
    localStorage.setItem("token", token);
    localStorage.setItem("nickname", nickname);
    localStorage.setItem("gender", gender);
    localStorage.setItem("userId", userId);
    localStorage.setItem("admin", admin ?? 0);
    setUser({ nickname, token, gender, userId, admin: Number(admin ?? 0) });
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("nickname");
    localStorage.removeItem("gender");
    localStorage.removeItem("userId");
    localStorage.removeItem("admin");
    setUser(null);
    navigate("/welcome");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};